
import Vue from 'vue';
import SelectPicker, { Option } from '@/components/SelectPicker.vue';

export default Vue.extend({
	components: {SelectPicker},
	props: {
		enabled: {
			type: Boolean,
			default: false,
		},
		canLogin: Boolean,
		username: String as () => string|undefined,
	},
	computed: {
		options(): Option[] {
			const r: Option[] = [];
			if (this.canLogin && !this.username) {
				r.push({label: 'Log in', value: 'login'});
			}
			if (this.canLogin && this.username) {
				r.push({label: 'Log out', value: 'logout'});
			}
			return r;
		}
	},
	methods: {
		handle(value: string) {
			if (value === 'login') {
				this.$emit('login');
			} else if (value === 'logout') {
				this.$emit('logout');
			}
		}
	}
})

